
export default function() {

	const app = document.querySelector( '#js-isVisible' );
	const number = document.querySelectorAll( '.js-numberCount' );

	number.forEach( function( element ) {

		const start = 0;
		const end = element.getAttribute( 'data-number' ) ? parseInt( element.getAttribute( 'data-number' ) ) : 0;

		/**
		 *
		 * @param element
		 * @param start
		 * @param end
		 * @param duration
		 */
		function animateValue( element, start, end, duration ) {

			// assumes integer values for start and end
			const obj = element;
			const range = end - start;
			// no timer shorter than 50ms (not really visible any way)
			const minTimer = 50;
			// calc step time to show all intermediate values
			let stepTime = Math.abs( Math.floor( duration / range ) );

			// never go below minTimer
			stepTime = Math.max( stepTime, minTimer );

			// get current time and calculate desired end time
			const startTime = new Date().getTime();
			const endTime = startTime + duration;
			let timer;

			/**
			 *
			 */
			function run() {

				const now = new Date().getTime();
				const remaining = Math.max( ( endTime - now ) / duration, 0 );
				const value = Math.round( end - ( remaining * range ) );
				obj.innerHTML = value.toLocaleString();

				if ( value === end ) {

					clearInterval( timer );

				}

			}

			timer = setInterval( run, stepTime );
			run();

		}

		let observer = new IntersectionObserver( function( entries, obs ) {

			entries.forEach( function( entry ) {

				// If the entry is not in the viewport, do nothing
				if ( ! entry.isIntersecting ) {

					return;

				}

				// Stop observing
				obs.unobserve( entry.target );

				// Animate numbers
				animateValue( element, start, end, 2000 );
				app.classList.add( 'start' );

			} );

		}, { threshold: [ 0.5 ] } );

		observer.observe( app );

	} );

}
